import { useConfig } from '../context/ConfigContext';
import { getFiscalIdConfig, FiscalIdConfig } from '../utils/fiscalIdentifier';

export function useFiscalIdConfig(): FiscalIdConfig {
  const { country } = useConfig();
  return getFiscalIdConfig(country);
}
